import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { validateSurface } from '../../globals.js';
import styles from './line.module.scss.js';

/**
 * @component Lines
 * @package Line
 * @document ../_docs/code/Line.editor.tsx
 * @document ../_docs/code/Line.snippet.tsx
 * @document ../_docs/code/Line.import.tsx
 */
const Line = (_a) => {
    var { surface: surfaceProp = 'lightPrimary', color = 'subtle', orientation = 'horizontal', id } = _a, rest = __rest(_a, ["surface", "color", "orientation", "id"]);
    const surface = validateSurface(surfaceProp);
    const lineStyles = [
        styles.line,
        styles[orientation],
        styles[surface.toLowerCase()],
    ];
    if (color === 'subtle' || color === 'strong')
        lineStyles.push(styles[color]);
    const customStyles = color !== 'subtle' && color !== 'strong'
        ? { backgroundColor: color }
        : undefined;
    return (jsx("div", Object.assign({}, rest, { className: lineStyles.join(' '), id: id }, (customStyles && { style: customStyles }))));
};

export { Line, Line as default };
